module.exports = __webpack_public_path__ + "img/engagement-photo-5.057f2a1e.jpg";